const sti =[
        
    
    { 
    label:"Infective agent",
    controlType:"text",
    options:[]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }


    
]

export default sti